import Select from 'react-select'
import { SelectStyles } from '../../../components/Select'
import { useThemeMode } from '../../../_metronic/partials'

interface SelectFilterProps {
  value: string
  onChange: (v: string) => void
  options: { label: string; value: string }[]
  label?: string
  placeholder?: string
  isSearchable?: boolean
  isClearable?: boolean
}

/**
 * Themed react-select filter for FilterManager (single-select).
 *
 * Visual style follows project's `SelectStyles(theme)`. Use this for any
 * non-trivial dropdown filter — it integrates with the dark theme automatically.
 *
 * For multi-value use `'selectMulti'`. For a plain native `<select>` use `'selectNative'`.
 *
 * @example
 * <FilterManager
 *   activeFilters={[{ filter: 'select', fieldName: 'direction' }]}
 *   filterProps={{
 *     direction: {
 *       label: 'Направление',
 *       options: [{value: 'in', label: 'Вход'}, {value: 'out', label: 'Выход'}],
 *       isSearchable: false,  // optional; defaults to true
 *     }
 *   }}
 *   onApplyFilters={(f) => console.log(f.direction)}  // 'in' | 'out' | ''
 * />
 */
export function SelectFilter({
  value,
  onChange,
  options,
  label,
  placeholder = 'Все',
  isSearchable = true,
  isClearable = true,
}: SelectFilterProps) {
  const { mode: theme } = useThemeMode()
  const selected = options.find((o) => o.value === value) ?? null

  return (
    <>
      {label && (
        <label className='fs-7 form-label fw-bolder text-dark mb-1'>{label}</label>
      )}
      <Select
        value={selected}
        onChange={(opt) => onChange(((opt as { value?: string } | null)?.value) ?? '')}
        options={options}
        placeholder={placeholder}
        isSearchable={isSearchable}
        isClearable={isClearable}
        styles={SelectStyles(theme) as any}
      />
    </>
  )
}
